import {reducerFactory} from '../../lib/asyncUtil'
import {EMAILS} from '../actionTypes'

export default reducerFactory(EMAILS)
